import {
	Socket
} from "./socket.js"
const socketUtil = {
	data() {
		return {
			//路径
			// providerSocketUrl: "ws://192.168.2.251:8106/ws/provider/",
			// orderSocketUrl: "ws://192.168.2.251:8106/ws/order/",
			//正式路径
			providerSocketUrl: "wss://www.wx.gddx-v1.com/ws/provider/",
			orderSocketUrl: "wss://www.wx.gddx-v1.com/ws/order/",
			//socket实例
			providerSocket: null,
			orderSocket: null,
			engineerName:null,
			page:0
		}
	},
	mounted() {

	},
	methods: {
		initSocketDD(id) {
			//初始化socket实例
			this.providerSocket = new Socket(this.providerSocketUrl, 'provider-'+id, this.acceptProviderData);
			this.providerSocket.createSocket();
			this.orderSocket = new Socket(this.orderSocketUrl, 'order-'+id, this.acceptOrderData);
			this.orderSocket.createSocket();
		},
		//查询服务商分页
		getServiceProviderPage(){
			console.log('55555555555555555555查询服务商分页')
			let param = {
			  providerPageSearchDto : {
				  size : 10,
				  page : this.page,
				  longitude : 113.7550342,
				  latitude : 23.0361437,
				  searchDto : {
					  receiveNick : this.engineerName
				  }
			  }
			}
			this.providerSocket.doOperation("getServiceProviderPage",param)
		},
		//查询范围内服务商
		getProviderByPosition(){
			let param = {
			  providerPositionSearchDto : {
				  longitude : 113.7550342,
				  latitude : 23.0361437,
				  scope: 50000000000000000,
				//   isOnline:false
			  }
			}
			this.providerSocket.doOperation("getProviderByPosition",param)
		}
	}
}

export {
	socketUtil
}



// WEBPACK FOOTER //
// ./src/utils/dd-websocket/socketUtil.js